import { getApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'

import { globalApi, listenFirebase, removeFirebase, setFirebase } from 'modules/App/globalApi'
import { PURCHASE_REPORT_FUNCTION } from './reportsUtils'

export const reportsApi = globalApi.injectEndpoints({
  endpoints: (build) => ({
    // The callable checks that the caller is an admin of the org or a Trybe
    // admin, caps the range at one year, and strips internal fields from rows.
    getPurchaseReport: build.mutation({
      queryFn: async ({ coachOrgId, from, to, includeEmails = false }) => {
        try {
          const getReport = httpsCallable(getFunctions(getApp()), PURCHASE_REPORT_FUNCTION)
          const { data } = await getReport({ coachOrgId, from, to, includeEmails })
          return { data }
        } catch (err) {
          return { error: { code: err?.code, message: err?.message, details: err?.details } }
        }
      },
    }),
    listenTrackedLinks: build.query({
      queryFn: () => ({ data: { isLoading: true } }),
      onCacheEntryAdded: async ({ coachOrgId }, api) => {
        listenFirebase(`coachOrgs/${coachOrgId}/trackedLinks`, api)
      },
    }),
    // The link's id is its utm_campaign slug, so two links can never share a
    // campaign. The page checks for a taken slug before saving.
    createTrackedLink: build.mutation({
      queryFn: async ({ coachOrgId, link }) => {
        const { data, error } = await setFirebase(`coachOrgs/${coachOrgId}/trackedLinks/${link.utm_campaign}`, link)
        return { data, error }
      },
    }),
    deleteTrackedLink: build.mutation({
      queryFn: async ({ coachOrgId, linkId }) => {
        const { data, error } = await removeFirebase(`coachOrgs/${coachOrgId}/trackedLinks/${linkId}`)
        return { data, error }
      },
    }),
  }),
})

export const {
  useGetPurchaseReportMutation,
  useListenTrackedLinksQuery,
  useCreateTrackedLinkMutation,
  useDeleteTrackedLinkMutation,
} = reportsApi
